import React from "react";
import { PageEditorContainer } from "./styled";
import { usePagesStore } from "../../../stores/use-page-store";
import DynamicPages from "../data/DynamicPages";
import ManualPages from "../data/ManualPages";
import EditingTabs from "../tabs/EditingTabs";

function PagesEditor() {
  const { data, selectedTab } = usePagesStore((state) => ({
    data: state.data,
    selectedTab: state.getSelectedTab(),
  }));

  const { enrichment } = data.config.tabs[selectedTab] || {};

  return (
    <PageEditorContainer>
      <EditingTabs />
      {enrichment === "dynamic" && <DynamicPages />}
      {enrichment === "manually" && <ManualPages isEdit />}
    </PageEditorContainer>
  );
}

export default PagesEditor;
